<section class="account-onboarding container-box" *ngIf="!isComplete">
  <div class="card-header d-flex align-items-center border-0">
    <div class="title flex-fill">Quick-start guide</div>

    <a class="btn btn-outline-light" href="https://advance.cm/help" target="_blank">
      <i class="far fa-question-circle"></i>
      <ng-container i18n>Help Center</ng-container>
    </a>
  </div>

  <div class="card-body pt-0 align-items-start">
    <div class="sidebar">
      <ul class="sections list-unstyled m-0">
        <li
          *ngFor="let section of sections; trackBy: trackBySection"
          class="section"
          (click)="selectSection(section)"
          [class.active]="section.title === selectedSection.title"
        >
          <div class="icon">
            <img [src]="section.icon" [alt]="section.title" width="36" height="36" />
          </div>
          <div class="info">
            <div class="label">{{ section.title }}</div>
            <div class="text-light text-sm">
              {{ getCompletedSteps(section) }}/{{ section.tasks.length }}
              <ng-container i18n>Completed</ng-container>
            </div>
          </div>
        </li>
      </ul>
      <div class="mt-3">
        <ngb-progressbar
          type="success"
          [animated]="true"
          [value]="overallProgress"
          class="shadow-none"
          style="height: 12px"
        ></ngb-progressbar>
        <div class="text-light text-sm text-right">
          {{ totalCompleted }}/{{ totalSteps }}
          <ng-container i18n>Completed</ng-container>
        </div>
      </div>
    </div>

    <div class="main-panel flex-fill">
      <ngb-accordion #taskAccordion="ngbAccordion" class="task-accordion" [closeOthers]="true">
        <ngb-panel
          *ngFor="let task of selectedSection.tasks; trackBy: trackByTask"
          [id]="task.id"
          [cardClass]="'task-panel ' + (task.completed ? 'completed' : '')"
          [disabled]="!isPretaskCompleted(task)"
        >
          <ng-template ngbPanelHeader let-opened="opened">
            <div
              class="task-header d-flex align-items-center clickable"
              (click)="taskAccordion.toggle(task.id)"
              [matTooltip]="task.disabledTooltip"
              [matTooltipDisabled]="isPretaskCompleted(task)"
            >
              <div class="indicator" [class.checked]="isPretaskCompleted(task) && task.completed">
                <span class="text-sm d-inline-flex" *ngIf="isPretaskCompleted(task) && task.completed">
                  <i class="cs-icon cs-icon-check2"></i>
                </span>
                <span class="text-sm d-inline-flex" *ngIf="!isPretaskCompleted(task)">
                  <i class="far fa-lock"></i>
                </span>
              </div>
              <div class="content">
                <div class="text-lg text-semi-bold">{{ task.title }}</div>
              </div>
              <div class="ml-auto">
                <i class="fas fa-chevron-down" *ngIf="!opened"></i>
                <i class="fas fa-chevron-up" *ngIf="opened"></i>
              </div>
            </div>
          </ng-template>
          <ng-template ngbPanelContent>
            <p class="description" *ngIf="task.description; else defaultTaskCopy">{{ task.description }}</p>
            <ng-template #defaultTaskCopy>
              <p class="description" i18n>Complete this step to continue optimizing your account.</p>
            </ng-template>
            <div class="task-actions">
              <button type="button" class="btn btn-info" (click)="onCompleteTask(task)">
                <i [class]="task.ctaIcon" *ngIf="task.ctaIcon"></i>
                <img [src]="task.ctaIconImage" alt="" height="13" *ngIf="task.ctaIconImage" />
                <ng-container i18n>{{ task.ctaText }}</ng-container>
              </button>
              <button type="button" class="btn btn-light" (click)="onSkipTask(task)" *ngIf="!task.noSkip">
                <ng-container i18n>Skip</ng-container>
              </button>
            </div>
          </ng-template>
        </ngb-panel>
      </ngb-accordion>
    </div>

    <div class="position-relative d-flex justify-content-center" *ngIf="totalCompleted !== totalSteps">
      <img [src]="selectedSection.videoImage" width="290" />
      <button
        type="button"
        class="btn btn-outline-light position-absolute"
        style="bottom: 1rem"
        (click)="onViewVideo(selectedSection.videoId)"
      >
        <i class="cs-icon cs-icon-play"></i>
        <ng-container i18n>Watch tutorial</ng-container>
      </button>
    </div>
  </div>
</section>
